var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
export default styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  z-index: 25;\n  height: ", "px;\n  background-color: ", ";\n  box-shadow: ", ";\n"], ["\n  position: relative;\n  z-index: 25;\n  height: ", "px;\n  background-color: ", ";\n  box-shadow: ", ";\n"])), function (_a) {
    var isMobile = _a.isMobile;
    return (isMobile ? 8 : 10);
}, function (_a) {
    var brandColor = _a.brandColor;
    return (brandColor);
}, function (_a) {
    var theme = _a.theme;
    return theme.shadows.inset.low;
});
var templateObject_1;
